import { TextField } from '@dhl-ui/components'

import type { RenderProps } from '~/modules/ppp/components/renderers/types'
import { estimateLines } from '~/modules/ppp/helpers'

/*
 * Stolen from https://stackoverflow.com/questions/376373/pretty-printing-xml-with-javascript/
 * ...and modified heavily
 */
/* eslint-disable no-useless-escape */
const formatXml = (xml: string, indentChar = '  '): string =>
  xml
    .split(/>\s*</)
    .reduce(
      ({ output, currentIndent }, node) => {
        if (node.match(/^\/\w/)) {
          currentIndent = currentIndent.substring(indentChar.length)
        }
        const line = `${currentIndent}<${node}>\r\n`
        if (node.match(/^<?\w[^>]*[^\/]$/)) {
          currentIndent += indentChar
        }
        return { output: output + line, currentIndent }
      },
      { output: '', currentIndent: '' }
    )
    .output.substring(1)
/* eslint-enable no-useless-escape */

// TODO: How to use in new design system?
export const XmlRenderer = ({ value }: RenderProps) => (
  <>
    <TextField fullWidth multiline value={formatXml(value)} disabled />
  </>
)
